import { alpha, type Theme } from "@mui/material/styles";
import ProposalField from "work/proposals/proposal-fields/proposal-field";

export function fieldHasPendingChange(fields: readonly ProposalField[] | undefined, field: ProposalField): boolean {
  return fields?.some((pendingField) => pendingField.isEqualTo(field)) ?? false;
}

export function fieldOrCommentFieldHasPendingChange(
  fields: readonly ProposalField[] | undefined,
  field: ProposalField,
): boolean {
  return (
    fields?.some((pendingField) => pendingField.isEqualTo(field) || pendingField.commentField.isEqualTo(field)) ??
    false
  );
}

export function pendingChangeOutlinedFieldStyles(theme: Theme) {
  const underlineColor = alpha(theme.palette.info.main, 0.95);
  const glowColor = alpha(theme.palette.info.main, 0.22);

  return {
    boxShadow: `inset 0 -2px 0 ${underlineColor}, 0 6px 8px -8px ${glowColor}`,
    "& .MuiOutlinedInput-root:not(.Mui-error)": {
      backgroundColor: alpha(theme.palette.info.main, 0.025),
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  };
}

export function pendingChangeContainerStyles(theme: Theme) {
  const underlineColor = alpha(theme.palette.info.main, 0.95);
  const glowColor = alpha(theme.palette.info.main, 0.22);

  return {
    backgroundColor: alpha(theme.palette.info.main, 0.025),
    boxShadow: `inset 0 -2px 0 ${underlineColor}, 0 6px 8px -8px ${glowColor}`,
  };
}

export function pendingChangeListItemStyles(theme: Theme) {
  const underlineColor = alpha(theme.palette.info.main, 0.95);
  const glowColor = alpha(theme.palette.info.main, 0.22);

  return {
    backgroundColor: alpha(theme.palette.info.main, 0.025),
    boxShadow: `inset 0 -2px 0 ${underlineColor}, 0 6px 8px -8px ${glowColor}`,
    "&:hover": {
      backgroundColor: alpha(theme.palette.info.main, 0.045),
    },
  };
}

export function pendingChangeTableRowStyles(theme: Theme) {
  const underlineColor = alpha(theme.palette.info.main, 0.95);
  const glowColor = alpha(theme.palette.info.main, 0.22);

  return {
    "& > td": {
      backgroundColor: alpha(theme.palette.info.main, 0.025),
      borderBottomColor: underlineColor,
      boxShadow: `inset 0 -2px 0 ${underlineColor}, 0 6px 8px -8px ${glowColor}`,
    },
  };
}
